<template>
    <div class="pt-2 pb-4 h-full flex gap-3">
        <div class="flex flex-col gap-3 items-center w-[48%]">
            <h3>Справочники</h3>
            <ai-grid-edit
                :meta="metaRefbook"
                ref="gridRefbookRef"
                class="w-[100%]"
            />
        </div>
        <div class="flex flex-col gap-3 items-center w-[48%]">
            <h3>{{ bookName ?? 'ㅤ' }}</h3>
            <ai-grid-edit
                :meta="metaRefcode"
                ref="gridRefcodeRef"
                class="w-[100%]"
                :args="args"
            />
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';
import { metaRefbook, metaRefcode, getRefobjectData } from './meta.js';

const gridRefbookRef = ref();
const gridRefcodeRef = ref();
const kodRefbook = ref(null);
const bookName = ref('ㅤ');

const args = computed(() => ({
    select: {
        select_args: {
            kod_refbook: kodRefbook.value,
        },
    },
    save: {
        insert_args: {
            kod_refbook: kodRefbook.value,
        },
        update_args: {
            kod_refbook: kodRefbook.value,
        },
    },
}));

onMounted(async () => {
    await gridRefbookRef.value.setCacheOrApiDataSource();
    await getRefobjectData();
    gridRefbookRef.value.gridInstance.on('cellClick', refbookRowClick);
});

const refbookRowClick = async event => {
    if (event.rowType !== 'data') return;
    kodRefbook.value = event.key;
    bookName.value = event.row.data.name;
    args.value.select.select_args.kod_refbook = kodRefbook.value;
    await gridRefcodeRef.value.setDataSource(false, args.value.select);
};
</script>
